module.exports = __webpack_public_path__ + "static/media/EP01@l.d1db976f.jpg";